import React, { createContext, useState } from 'react';

const RateLimitContext = createContext();

const RateLimitProvider = ({ children }) => {
    const [latestFamilyTreeFetch, setLatestFamilyTreeFetch] = useState();

    // Value object to be provided by the context
    const value = {
        latestFamilyTreeFetch,
        setLatestFamilyTreeFetch,
    };

    // Render the provider with the provided children
    return (
        <RateLimitContext.Provider value={value}>
            {children}
        </RateLimitContext.Provider>
    );
};

export { RateLimitProvider, RateLimitContext };